// ProtectedRoutes.tsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthSessionValid } from "./utils/authSession";
import { logout } from "./utils/logout";

const ProtectedRoutes: React.FC = () => {
  if (!isAuthSessionValid()) {
    localStorage.clear();
    logout({ redirectToLogin: true });
    return null;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
